import React from 'react'
import { Controller, Control } from 'react-hook-form'
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap'

interface Props {
  name: string
  label: string
  control: Control<any>
  placeholder?: string
  maxLength?: number
}

const ICSTextInput = ({
  name,
  label,
  control,
  placeholder,
  maxLength
}: Props) => (
  <FormGroup>
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const currentLength = field.value?.length || 0

        return (
          <>
            <Label for={name} className="d-flex justify-content-between">
              <span>{label}</span>
              {maxLength !== undefined && (
                <small className="text-muted">{`${currentLength}/${maxLength}`}</small>
              )}
            </Label>
            <Input
              id={name}
              type="text"
              {...field}
              maxLength={maxLength}
              placeholder={placeholder || `${label}...`}
              invalid={!!fieldState.error}
            />
            {fieldState.error && (
              <FormFeedback>{fieldState.error.message}</FormFeedback>
            )}
          </>
        )
      }}
    />
  </FormGroup>
)

export default ICSTextInput
